export const mockedUrls: Array<string | RegExp> = [
  'test',
  'country-url',
  'occupations-url',
];

export default function urlIsMocked(urlString: string): boolean {
  let foundMock = false;
  mockedUrls.forEach((url: string | RegExp): void => {
    if (typeof url === 'string') {
      if (url === urlString) {
        foundMock = true;
      }
    } else if (url.test(urlString)) {
      foundMock = true;
    }
  });

  return foundMock;
}
